import { CaseDeserialized } from "src/cases/queries/casesTypes";
import { useWorkspaceFeatureGates } from "src/hooks/useWorkspaceFeatureGates";

export const useIsCaseCopilotEnabled = (
  caseData?: CaseDeserialized,
): boolean => {
  const { cmCopilotEnabled } = useWorkspaceFeatureGates();
  return (
    cmCopilotEnabled &&
    caseData?.data.template_version?.copilot_settings?.copilot_enabled ===
      true &&
    caseData?.data.template_version?.copilot_reference != null
  );
};
